import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#arrow-up_svg__a)">
      <path
        fill="#263E6A"
        d="M3.333 17.333 2 16 12 6l10 10-1.333 1.333L12 8.667z"
      />
    </g>
    <defs>
      <clipPath id="arrow-up_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgArrowUp;
